import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { useCookies } from "react-cookie";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";

function Company() {
  const location = useLocation();
  const [cookies] = useCookies(["userToken", "userRole"]);
  const mainContentRef = React.useRef(null);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout.includes("company")) {
        return (
          <Route
            exact={prop.exact}
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const companyRoutes = routes.filter((route) => route.layout === "/company");

  if (!cookies.userToken || cookies.userRole !== "company") {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Sidebar routes={companyRoutes} />
      <div
        ref={mainContentRef}
        style={{ marginLeft: "250px", width: "calc(100vw-250px)" }}
      >
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/company/shops" />
        </Switch>
      </div>
    </>
  );
}

export default Company;
